import {Icon, type IconType} from 'src/common/Icon'

type Props = {
  text: string
  iconName: IconType
}

export const InfoRow = ({text, iconName}: Props) => (
  <div className="flex items-center gap-2 text-15 font-medium leading-[20px] text-moss-black">
    <Icon name={iconName} className="size-5 text-moss-grey-300" />
    <span>{text}</span>
  </div>
)
